/**
 * i18n bundle for the generic Data Import/Export wizard (`dataio` namespace).
 * Wizard chrome + per-resource field labels referenced by `ImportFieldSpec.labelKey`.
 */

export const dataIoPtBr = {
  importCsv: 'Importar CSV',
  exportCsv: 'Exportar CSV',
  importBankAccounts: 'Importar dados bancários',
  exportBankAccounts: 'Exportar dados bancários',
  moreActions: 'Mais ações',
  bankAccountsResource: 'dados bancários de fornecedores',
  arInvoicesResource: 'recebíveis (faturas de clientes)',
  arPreBillingResource: 'pré-faturamento',
  exportFiltered: 'Exportar filtrados ({{count}})',
  exportAll: 'Exportar todos ({{count}})',
  exportEmpty: 'Nada para exportar',
  export: {
    preview: 'Pré-visualizar…',
    description: 'Confira o que será exportado e baixe o arquivo CSV.',
    summary: '{{count}} registro(s) serão exportados',
    previewHeading: 'Prévia',
    more: '+{{count}} linha(s) não exibida(s)',
    download: 'Baixar CSV',
    empty: 'Nada para exportar',
    scopeFiltered: 'Filtrados ({{count}})',
    scopeAll: 'Todos ({{count}})',
  },
  title: 'Importar {{resource}}',
  description: 'Envie um arquivo CSV, ajuste o mapeamento das colunas e processe.',
  steps: {
    upload: 'Arquivo',
    mapping: 'Mapeamento',
    duplicates: 'Duplicatas',
    result: 'Resultado',
    uploadDesc: 'Selecione o arquivo CSV',
    mappingDesc: 'Associe as colunas',
    duplicatesDesc: 'Revise possíveis duplicatas',
    resultDesc: 'Resumo da importação',
  },
  upload: {
    dropzone: 'Arraste um arquivo CSV aqui ou clique para selecionar',
    dropActive: 'Solte o arquivo CSV aqui',
    fileLabel: 'Arquivo',
    columns: 'colunas',
    rows: 'linhas',
    downloadTemplate: 'Baixar modelo',
    invalidType: 'Selecione um arquivo CSV',
    empty: 'O arquivo está vazio',
    importAsMigrated: 'Importar como migradas',
    importAsMigratedHelp:
      'Histórico do sistema anterior: sem lançamento contábil, sem NFS-e, sem conciliação. Visível só na aba Todas.',
  },
  mapping: {
    title: 'Mapeie as colunas do arquivo',
    description:
      'Associe cada campo do sistema a uma coluna do seu arquivo. Campos obrigatórios são destacados.',
    required: 'Obrigatório',
    optional: 'Opcional',
    noColumn: 'Não mapear',
    column: 'Coluna do arquivo',
    field: 'Campo do sistema',
    preview: 'Prévia dos dados',
    missingRequired: 'Mapeie todos os campos obrigatórios para continuar.',
    legendSuggestion: 'Sugestão Alchemy',
  },
  result: {
    title: 'Importação concluída',
    successTitle: 'Importação concluída com sucesso',
    processed: '{{count}} linha(s) processada(s)',
    created: '{{count}} criada(s)',
    updated: '{{count}} atualizada(s)',
    skipped: '{{count}} ignorada(s)',
    errors: '{{count}} com erro',
    informationTitle: 'Informações da importação',
    informationSummary: '{{count}} tipo(s) de informação em {{rows}} linha(s)',
    showDetails: 'Ver detalhes',
    hideDetails: 'Ocultar detalhes',
    rows: '{{count}} linha(s)',
    detailRows: 'Linhas: {{rows}}',
    errorsTitle: 'Erros',
    errorRow: 'Linha {{row}}',
    noErrors: 'Nenhum erro.',
    asyncAcceptedTitle: 'Importação recebida',
    asyncAcceptedDescription:
      '{{count}} linhas serão processadas em segundo plano. Você pode fechar esta janela com segurança.',
    asyncJobId: 'Lote {{jobId}}',
    asyncHistoryHint: 'Acompanhe o progresso e eventuais erros no histórico de lotes.',
  },
  duplicates: {
    title: 'Possíveis duplicatas encontradas',
    description:
      '{{count}} linha(s) parecem já existir. Escolha se cada linha deve ser ignorada, atualizada ou criada como nova.',
    diffLabel: '{{field}} difere',
    footerLedger:
      '{{skip}} ignorar · {{update}} atualizar · {{link}} vincular · {{create}} criar · {{pending}} pendentes',
    score: '{{score}}% de similaridade',
    imported: 'Linha importada',
    identicalMessage: 'Tudo igual à fatura existente',
    fiscalNoteMatchMessage: 'NFS-e emitida encontrada com correspondência exata',
    sourceIdMatch: 'ID de origem já importado: {{sourceId}}',
    sourceIdReviewMessage: 'ID repetido; confira os dados antes de atualizar',
    existing: 'Fatura existente',
    groupCount: '{{count}} linhas',
    groupDifferenceCount: '{{count}} com diferença',
    nfAbbrev: 'NF',
    nonDraftBlocked: 'Esta fatura existente não está em rascunho, então não pode ser atualizada.',
    quickActions: 'Ações rápidas:',
    summaryTitle: '{{count}} linhas já parecem existir',
    summary: {
      identical: 'idênticas',
      suppliers: 'fornecedores',
      withDifferences: 'com diferenças',
    },
    columns: {
      action: 'Ação',
      match: 'Correspondência',
    },
    fields: {
      customer: 'Cliente',
      invoiceNumber: 'Número da fatura',
      grossAmount: 'Valor bruto',
      dueDate: 'Vencimento',
      currentStatus: 'Status atual',
      status: 'Status',
    },
    actions: {
      all: 'Todos',
      applyAll: 'Aplicar {{action}} a todas as linhas',
      createNew: 'Criar',
      createAll: 'Criar todas como novas {{count}}',
      createAllShort: 'Criar todas',
      group: 'Grupo',
      ignoreAll: 'Ignorar todas',
      ignoreIdentical: 'Ignorar idênticas {{count}}',
      reviewDifferences: 'Revisar só as diferenças {{count}}',
      skip: 'Ignorar',
      updateExisting: 'Atualizar',
      linkFiscalNote: 'Vincular nota existente',
      doNotImport: 'Não importar',
      updateInvoice: 'Atualizar fatura',
      importAndLink: 'Importar e vincular NFS-e',
      importWithoutLink: 'Importar sem vínculo',
      createAnotherInvoice: 'Criar outra fatura',
      doNotImportAll: 'Não importar nenhuma ({{count}})',
      importAndLinkAll: 'Importar e vincular NFS-e ({{count}})',
      updateAll: 'Atualizar faturas ({{count}})',
      importAsNewAll: 'Importar como novas ({{count}})',
      doNotImportGroup: 'Não importar',
      importAndLinkGroup: 'Importar e vincular',
      importAsNewGroup: 'Importar como novas',
    },
    statuses: {
      DRAFT: 'Rascunho',
      ISSUED: 'Emitida',
      PAID: 'Paga',
      PAID_UNCONFIRMED: 'Pago (a confirmar)',
      // ALC-2824 — parcelas da adquirente ainda chegando; o cliente não deve nada.
      PARTIALLY_RECEIVED: 'Recebido parcial',
      PARTIALLY_PAID: 'Parcialmente paga',
      VOID: 'Cancelada',
      MIGRATED: 'Migrada',
      NFSE_AUTHORIZED: 'NFS-e autorizada',
    },
  },
  actions: {
    cancel: 'Cancelar',
    back: 'Voltar',
    inspecting: 'Analisando...',
    import: 'Importar',
    confirmImport: 'Confirmar importação',
    importing: 'Importando...',
    importMore: 'Importar mais',
    close: 'Fechar',
  },
  errors: {
    inspectFailed: 'Não foi possível analisar o arquivo.',
    importFailed: 'Não foi possível concluir a importação.',
    arBatchSourceRequired:
      'Para importar mais de 50 linhas, o arquivo precisa ter a coluna Id_cobranca com um identificador único por cobrança.',
    idempotencyCleanupFailed:
      'A importação foi recebida, mas a chave local não pôde ser limpa. Consulte o histórico antes de enviar novamente.',
    idempotencyCryptoUnavailable:
      'Não foi possível calcular a identidade segura do arquivo. Use um navegador moderno em uma conexão segura e tente novamente.',
  },
  fields: {
    arInvoices: {
      entityName: 'Entidade',
      invoiceNumber: 'Número da fatura',
      issueDate: 'Data de emissão',
      dueDate: 'Data de vencimento',
      competencyDate: 'Competência',
      managerialDate: 'Data gerencial',
      customerTaxId: 'CNPJ/CPF do cliente',
      customerName: 'Razão social do cliente',
      customerCode: 'Código do cliente',
      customerEmail: 'E-mail do cliente',
      currency: 'Moeda',
      serviceCode: 'Código Serviço',
      description: 'Descrição',
      grossAmount: 'Valor bruto',
      netAmount: 'Valor líquido',
      irrf: 'IRRF',
      inss: 'INSS',
      pisRetido: 'PIS retido',
      cofinsRetido: 'COFINS retido',
      csllRetido: 'CSLL retido',
      issRetido: 'ISS retido pelo cliente',
      issProprio: 'ISS próprio (provisionamento)',
      externalFiscalNoteNumber: 'Número da NF externa',
      externalFiscalNoteIssueDate: 'Data de emissão da NF externa',
    },
    costCenter: {
      entityName: 'Entidade',
      code: 'Código',
      name: 'Nome',
      description: 'Descrição',
      aiContext: 'Contexto de IA',
      ownerUserEmail: 'E-mail do responsável',
      isMECE: 'É MECE',
      requiresMigrationIfInactivated: 'Exige migração se inativado',
    },
    department: {
      entityName: 'Entidade',
      name: 'Nome',
      description: 'Descrição',
      parentDepartmentName: 'Departamento pai',
      headUserEmail: 'E-mail do gestor',
      isMECE: 'É MECE',
      requiresMigrationIfInactivated: 'Exige migração se inativado',
    },
    vendor: {
      vendorCode: 'Código',
      legalName: 'Razão social',
      tradeName: 'Nome fantasia',
      status: 'Status',
      vendorType: 'Tipo',
      taxIdType: 'Tipo de documento',
      cnpj: 'CNPJ',
      cpf: 'CPF',
      taxRegime: 'Regime tributário',
      primaryContactName: 'Nome do contato',
      primaryContactEmail: 'E-mail do contato',
      primaryContactPhone: 'Telefone do contato',
    },
    vendorBankAccount: {
      vendorCode: 'Código do fornecedor',
      bankCode: 'Código do banco',
      bankName: 'Banco',
      agency: 'Agência',
      agencyDigit: 'Dígito da agência',
      accountNumber: 'Conta',
      accountDigit: 'Dígito da conta',
      accountType: 'Tipo de conta',
      accountHolderName: 'Titular',
      pixKeyType: 'Tipo de chave PIX',
      pixKey: 'Chave PIX',
      isDefault: 'Conta padrão',
      isActive: 'Ativa',
      accountStatus: 'Status',
      verified: 'Verificada',
      verificationObservation: 'Observação da verificação',
    },
    hcmEmployee: {
      employeeNumber: 'Matrícula',
      name: 'Nome',
      taxId: 'CPF',
      birthDate: 'Data de nascimento',
      email: 'E-mail',
      phoneNumber: 'Telefone',
      employmentStatus: 'Situação',
      jobTitle: 'Cargo',
      orgUnitCode: 'Código da unidade',
      orgUnitName: 'Unidade organizacional',
      orgUnitEffectiveFrom: 'Vigência da unidade',
      dependentRelationship: 'Parentesco do dependente',
    },
    coa: {
      code: 'Código',
      name: 'Nome',
      accountType: 'Tipo de conta',
      naturalBalance: 'Natureza',
      parentCode: 'Código pai',
      description: 'Descrição',
      isPostable: 'Aceita lançamento',
      isContra: 'Conta redutora',
      contraOfCode: 'Código da conta base',
    },
    managerialAccount: {
      code: 'Código',
      name: 'Nome',
      description: 'Descrição',
      aiContext: 'Contexto de IA',
      accountType: 'Tipo de conta',
      parentCode: 'Código pai',
      effectiveStartDate: 'Início da vigência',
      effectiveEndDate: 'Fim da vigência',
      tags: 'Tags (JSON)',
    },
    bankAccount: {
      entityName: 'Entidade',
      name: 'Apelido da conta',
      description: 'Descrição',
      bankCode: 'Código do banco',
      bankName: 'Banco',
      branchCode: 'Agência',
      accountNumber: 'Número da conta',
      accountType: 'Tipo de conta',
      pixKeyEvp: 'PIX (aleatória)',
      pixKeyCnpj: 'PIX (CNPJ)',
      pixKeyEmail: 'PIX (e-mail)',
      pixKeyPhone: 'PIX (telefone)',
      cnabConvenio: 'CNAB convênio',
      cnabCarteira: 'CNAB carteira',
      cnabVariacao: 'CNAB variação',
      status: 'Status',
      isDefault: 'Padrão',
    },
  },
} as const;

export const dataIoEn = {
  importCsv: 'Import CSV',
  exportCsv: 'Export CSV',
  importBankAccounts: 'Import bank details',
  exportBankAccounts: 'Export bank details',
  moreActions: 'More actions',
  bankAccountsResource: 'vendor bank details',
  arInvoicesResource: 'receivables (customer invoices)',
  arPreBillingResource: 'pre-billing',
  exportFiltered: 'Export filtered ({{count}})',
  exportAll: 'Export all ({{count}})',
  exportEmpty: 'Nothing to export',
  export: {
    preview: 'Preview…',
    description: 'Review what will be exported and download the CSV file.',
    summary: '{{count}} record(s) will be exported',
    previewHeading: 'Preview',
    more: '+{{count}} row(s) not shown',
    download: 'Download CSV',
    empty: 'Nothing to export',
    scopeFiltered: 'Filtered ({{count}})',
    scopeAll: 'All ({{count}})',
  },
  title: 'Import {{resource}}',
  description: 'Upload a CSV file, adjust the column mapping, and process.',
  steps: {
    upload: 'File',
    mapping: 'Mapping',
    duplicates: 'Duplicates',
    result: 'Result',
    uploadDesc: 'Select the CSV file',
    mappingDesc: 'Match the columns',
    duplicatesDesc: 'Review possible duplicates',
    resultDesc: 'Import summary',
  },
  upload: {
    dropzone: 'Drag a CSV file here or click to select',
    dropActive: 'Drop the CSV file here',
    fileLabel: 'File',
    columns: 'columns',
    rows: 'rows',
    downloadTemplate: 'Download template',
    invalidType: 'Please select a CSV file',
    empty: 'The file is empty',
    importAsMigrated: 'Import as migrated',
    importAsMigratedHelp:
      'History from the previous system: no GL posting, no fiscal note, no reconciliation. Visible only in the All tab.',
  },
  mapping: {
    title: 'Map the file columns',
    description:
      'Match each system field to a column from your file. Required fields are highlighted.',
    required: 'Required',
    optional: 'Optional',
    noColumn: 'Do not map',
    column: 'File column',
    field: 'System field',
    preview: 'Data preview',
    missingRequired: 'Map all required fields to continue.',
    legendSuggestion: 'Alchemy suggestion',
  },
  result: {
    title: 'Import complete',
    successTitle: 'Import completed successfully',
    processed: '{{count}} row(s) processed',
    created: '{{count}} created',
    updated: '{{count}} updated',
    skipped: '{{count}} skipped',
    errors: '{{count}} with errors',
    informationTitle: 'Import information',
    informationSummary: '{{count}} information type(s) across {{rows}} row(s)',
    showDetails: 'View details',
    hideDetails: 'Hide details',
    rows: '{{count}} row(s)',
    detailRows: 'Rows: {{rows}}',
    errorsTitle: 'Errors',
    errorRow: 'Row {{row}}',
    noErrors: 'No errors.',
    asyncAcceptedTitle: 'Import accepted',
    asyncAcceptedDescription:
      '{{count}} rows will be processed in the background. You can safely close this window.',
    asyncJobId: 'Batch {{jobId}}',
    asyncHistoryHint: 'Track progress and any errors in the batch history.',
  },
  duplicates: {
    title: 'Possible duplicates found',
    description:
      '{{count}} row(s) look like existing invoices. Choose whether each row should be skipped, updated, or created as new.',
    diffLabel: '{{field}} differs',
    footerLedger:
      '{{skip}} skip · {{update}} update · {{link}} link · {{create}} create · {{pending}} pending',
    score: '{{score}}% similarity',
    imported: 'Imported row',
    identicalMessage: 'Everything matches the existing invoice',
    fiscalNoteMatchMessage: 'Exact match found for an issued service invoice',
    sourceIdMatch: 'Source ID already imported: {{sourceId}}',
    sourceIdReviewMessage: 'Repeated ID; review the data before updating',
    existing: 'Existing invoice',
    groupCount: '{{count}} rows',
    groupDifferenceCount: '{{count}} with difference',
    nfAbbrev: 'Inv.',
    nonDraftBlocked: 'This existing invoice is not a draft, so it cannot be updated.',
    quickActions: 'Quick actions:',
    summaryTitle: '{{count}} rows look existing',
    summary: {
      identical: 'identical',
      suppliers: 'suppliers',
      withDifferences: 'with differences',
    },
    columns: {
      action: 'Action',
      match: 'Match',
    },
    fields: {
      customer: 'Customer',
      invoiceNumber: 'Invoice number',
      grossAmount: 'Gross amount',
      dueDate: 'Due date',
      currentStatus: 'Current status',
      status: 'Status',
    },
    actions: {
      all: 'All',
      applyAll: 'Apply {{action}} to all rows',
      createNew: 'Create',
      createAll: 'Create all as new {{count}}',
      createAllShort: 'Create all',
      group: 'Group',
      ignoreAll: 'Ignore all',
      ignoreIdentical: 'Ignore identical {{count}}',
      reviewDifferences: 'Review only differences {{count}}',
      skip: 'Skip',
      updateExisting: 'Update',
      linkFiscalNote: 'Link existing fiscal note',
      doNotImport: 'Do not import',
      updateInvoice: 'Update invoice',
      importAndLink: 'Import and link service invoice',
      importWithoutLink: 'Import without link',
      createAnotherInvoice: 'Create another invoice',
      doNotImportAll: 'Do not import any ({{count}})',
      importAndLinkAll: 'Import and link service invoices ({{count}})',
      updateAll: 'Update invoices ({{count}})',
      importAsNewAll: 'Import as new ({{count}})',
      doNotImportGroup: 'Do not import',
      importAndLinkGroup: 'Import and link',
      importAsNewGroup: 'Import as new',
    },
    statuses: {
      DRAFT: 'Draft',
      ISSUED: 'Issued',
      PAID: 'Paid',
      PAID_UNCONFIRMED: 'Paid (unconfirmed)',
      // ALC-2824 — acquirer installments still arriving; the customer owes nothing.
      PARTIALLY_RECEIVED: 'Partially received',
      PARTIALLY_PAID: 'Partially paid',
      VOID: 'Void',
      MIGRATED: 'Migrated',
      NFSE_AUTHORIZED: 'Authorized service invoice',
    },
  },
  actions: {
    cancel: 'Cancel',
    back: 'Back',
    inspecting: 'Analyzing...',
    import: 'Import',
    confirmImport: 'Confirm import',
    importing: 'Importing...',
    importMore: 'Import more',
    close: 'Close',
  },
  errors: {
    inspectFailed: 'Could not analyze the file.',
    importFailed: 'Could not complete the import.',
    arBatchSourceRequired:
      'To import more than 50 rows, the file needs an Id_cobranca column with a unique identifier for each charge.',
    idempotencyCleanupFailed:
      'The import was accepted, but its local key could not be cleared. Check history before submitting it again.',
    idempotencyCryptoUnavailable:
      'Could not calculate a secure file identity. Use a modern browser over a secure connection and try again.',
  },
  fields: {
    arInvoices: {
      entityName: 'Entity',
      invoiceNumber: 'Invoice number',
      issueDate: 'Issue date',
      dueDate: 'Due date',
      competencyDate: 'Competency date',
      managerialDate: 'Managerial date',
      customerTaxId: 'Customer CNPJ/CPF',
      customerName: 'Customer name',
      customerCode: 'Customer code',
      customerEmail: 'Customer e-mail',
      currency: 'Currency',
      serviceCode: 'Service code',
      description: 'Description',
      grossAmount: 'Gross amount',
      netAmount: 'Net amount',
      irrf: 'IRRF',
      inss: 'INSS',
      pisRetido: 'PIS withheld',
      cofinsRetido: 'COFINS withheld',
      csllRetido: 'CSLL withheld',
      issRetido: 'ISS withheld by customer',
      issProprio: 'Own ISS (provisioning)',
      externalFiscalNoteNumber: 'External NF number',
      externalFiscalNoteIssueDate: 'External NF issue date',
    },
    costCenter: {
      entityName: 'Entity',
      code: 'Code',
      name: 'Name',
      description: 'Description',
      aiContext: 'AI context',
      ownerUserEmail: 'Owner e-mail',
      isMECE: 'Is MECE',
      requiresMigrationIfInactivated: 'Requires migration if inactivated',
    },
    department: {
      entityName: 'Entity',
      name: 'Name',
      description: 'Description',
      parentDepartmentName: 'Parent department',
      headUserEmail: 'Head e-mail',
      isMECE: 'Is MECE',
      requiresMigrationIfInactivated: 'Requires migration if inactivated',
    },
    vendor: {
      vendorCode: 'Vendor code',
      legalName: 'Legal name',
      tradeName: 'Trade name',
      status: 'Status',
      vendorType: 'Vendor type',
      taxIdType: 'Tax ID type',
      cnpj: 'CNPJ',
      cpf: 'CPF',
      taxRegime: 'Tax regime',
      primaryContactName: 'Contact name',
      primaryContactEmail: 'Contact e-mail',
      primaryContactPhone: 'Contact phone',
    },
    vendorBankAccount: {
      vendorCode: 'Vendor code',
      bankCode: 'Bank code',
      bankName: 'Bank name',
      agency: 'Agency',
      agencyDigit: 'Agency digit',
      accountNumber: 'Account number',
      accountDigit: 'Account digit',
      accountType: 'Account type',
      accountHolderName: 'Account holder',
      pixKeyType: 'PIX key type',
      pixKey: 'PIX key',
      isDefault: 'Default account',
      isActive: 'Active',
      accountStatus: 'Status',
      verified: 'Verified',
      verificationObservation: 'Verification note',
    },
    hcmEmployee: {
      employeeNumber: 'Employee number',
      name: 'Name',
      taxId: 'Tax ID',
      birthDate: 'Birth date',
      email: 'E-mail',
      phoneNumber: 'Phone',
      employmentStatus: 'Employment status',
      jobTitle: 'Job title',
      orgUnitCode: 'Org unit code',
      orgUnitName: 'Org unit name',
      orgUnitEffectiveFrom: 'Org unit effective from',
      dependentRelationship: 'Dependent relationship',
    },
    coa: {
      code: 'Code',
      name: 'Name',
      accountType: 'Account type',
      naturalBalance: 'Natural balance',
      parentCode: 'Parent code',
      description: 'Description',
      isPostable: 'Postable',
      isContra: 'Contra account',
      contraOfCode: 'Base account code',
    },
    managerialAccount: {
      code: 'Code',
      name: 'Name',
      description: 'Description',
      aiContext: 'AI context',
      accountType: 'Account type',
      parentCode: 'Parent code',
      effectiveStartDate: 'Effective start date',
      effectiveEndDate: 'Effective end date',
      tags: 'Tags (JSON)',
    },
    bankAccount: {
      entityName: 'Entity',
      name: 'Account label',
      description: 'Description',
      bankCode: 'Bank code',
      bankName: 'Bank name',
      branchCode: 'Branch code',
      accountNumber: 'Account number',
      accountType: 'Account type',
      pixKeyEvp: 'PIX (EVP)',
      pixKeyCnpj: 'PIX (CNPJ)',
      pixKeyEmail: 'PIX (e-mail)',
      pixKeyPhone: 'PIX (phone)',
      cnabConvenio: 'CNAB convênio',
      cnabCarteira: 'CNAB carteira',
      cnabVariacao: 'CNAB variação',
      status: 'Status',
      isDefault: 'Default',
    },
  },
} as const;
